import Vue from 'vue'

import {
  Row,
  Col,
  Input,
  Form,
  FormItem,
  Select,
  Option,
  DatePicker,
  OptionGroup,
  Radio,
  RadioGroup,
  Upload,
  Checkbox,
  MessageBox,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css';
locale.use(lang)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(OptionGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.prototype.$alert = MessageBox.alert;